/* eslint-disable no-console */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_GET_USERS, API_LOGIN, API_USERS_DETAIL } from '../configs/api'
import networkAdapter from '../utilities/networkAdapter'
import { paramsGet } from 'models/common'
import { reqCreateUser } from 'models/user'
import { bindParams } from 'utilities/helpers'

export interface LoginCredentialProps {
  name: string
  password: string
}

export const fetchLogin = async (loginCredential: LoginCredentialProps) => {
  try {
    const postApi = await networkAdapter.post(API_LOGIN, loginCredential)
    return postApi.data
  } catch (error) {
    console.log('error_login', error)
  }
}

export const fetchUser = createAsyncThunk('users/fetchApi', async (loginCredential: LoginCredentialProps) => {
  const response = await fetchLogin(loginCredential)
  return response
})

export const fetchListUser = async (params: paramsGet) => {
  try {
    const users = await networkAdapter.get(API_GET_USERS, params)
    return users.data
  } catch (error) {
    console.log('error get users', error)
  }
}

export const fetchUserDetail = async (userId: string) => {
  try {
    const users = networkAdapter.get(bindParams(API_USERS_DETAIL, {
      id: userId
    }))
    return users
  } catch (error) {
    console.log('error get users', error)
  }
}

export const postCreateUser = async (req: reqCreateUser) => {
  try {
    const users = networkAdapter.post(API_GET_USERS, req)
    return users
  } catch (error) {
    console.log('error get users', error)
  }
}

export const putUpdateUser = async (userId: number, req: reqCreateUser) => {
  try {
    const users = networkAdapter.put(
      bindParams(API_USERS_DETAIL, {
        id: userId
      }),
      req
    )
    return users
  } catch (error) {
    console.log('error get users', error)
  }
}

export const userAPI = {
  fetchLogin,
  fetchUser,
  fetchListUser
}
